import i18next from 'i18next'
import * as React from 'react'

import type { CameraType } from '../../../../shared/domain/flows/types.no-deps'
import { assumeExhaustion } from '../../../../shared/lib/typeHelpers.no-deps'

import { SVG_ImageCapture } from '../../svg/SVG_ImageCapture'
import { SVG_VideoCapture } from '../../svg/SVG_VideoCapture'
import Fragment from '../../ui/Fragment'

const CaptureButtons: React.SFC<{
    onClick: (uploadSource: 'camera', mediaType: CameraType) => () => Promise<void>
    isBrowser: boolean
    mediaType: CameraType
}> = ({ onClick, isBrowser, mediaType }) => {
    const handleClick = (mediaType: CameraType) => onClick('camera', mediaType)

    switch (mediaType) {
        case 'any':
            return (
                <Fragment>
                    <PhotoCapture key="photo" onClick={handleClick} />
                    <VideoCapture key="video" onClick={handleClick} isBrowser={isBrowser} />
                </Fragment>
            )
        case 'photo':
            return (
                <Fragment>
                    <PhotoCapture key="photo" onClick={handleClick} />
                </Fragment>
            )
        case 'video':
            return (
                <Fragment>
                    <VideoCapture key="video" onClick={handleClick} isBrowser={isBrowser} />
                </Fragment>
            )
        default:
            assumeExhaustion(mediaType)
            return <Fragment />
    }
}

const PhotoCapture: React.SFC<{
    onClick: (mediaType: CameraType) => () => Promise<void>
}> = ({ onClick }) => (
    <CameraCapture
        onClick={onClick('photo')}
        icon={SVG_ImageCapture}
        label={i18next.t('appcore:CaptureButtons.photo')}
        testId="photo-camera-button"
    />
)

const VideoCapture: React.SFC<{
    onClick: (mediaType: CameraType) => () => Promise<void>
    isBrowser: boolean
}> = ({ onClick }) => (
    <CameraCapture
        onClick={onClick('video')}
        icon={SVG_VideoCapture}
        label={i18next.t('appcore:CaptureButtons.video')}
        testId="video-camera-button"
    />
)

const CameraCapture = ({
    icon,
    label,
    onClick,
    testId,
}: {
    icon: () => JSX.Element
    label: string
    onClick: () => Promise<void>
    testId?: string
}) => {
    // JSX custom elements must start with capital letters
    const Icon = icon
    return (
        <div className="AppCore__flow__ElementCamera__button" data-testid={testId} onClick={onClick}>
            <div className="AppCore__flow__ElementCamera__button_inner">
                <Icon />
                <div className="AppCore__flow__ElementCamera__button_text">{label}</div>
            </div>
        </div>
    )
}

export default CaptureButtons
